import React, { Component } from 'react';
// import { getFileName } from '../../../../helpers/FileCaching';
// import globalJson from 'data/content.json';
// import IsNotDomestic from 'helpers/IsNotDomestic';
import VideoPlayer from 'components/Shared/VideoPlayer/VideoPlayer';
import classes from './Video.module.scss';

class Video extends Component {

	constructor(props) {
		super(props);

		this.globalImages = props.globalImages;

		this.videoWrapperRef = React.createRef();
	}

	render() {
		const video = this.props.content.video.map((item, index) => {
			const Video_html =
			<div  key={index}  className={`${classes.video__container}`}>
				<div className={`row`}>
					<div className={`col-lg-10 ${classes.video__videoWrapper}`}>
						<div key={index} className={classes.video} ref={this.videoWrapperRef}>
							<div className={classes['video__player-container']}>
								<VideoPlayer content={this.props.content.video} globalImages={this.props.globalImages} windowSize={this.props.windowSize} stylesOverride={classes.videoPlayerStyleOverride} />
							</div>
						</div>
					</div>
				</div>
			</div>
			
			return Video_html;
		});
	
		// return <section>{video}</section>
		return <>{video}</>
	}
}

export default Video;